import { useCallback } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  redirectToOAuthLogin,
  logoutCurrentSession,
  isDevTokenAuthActive,
} from '@/lib/auth/auth-session';
import { queryKeys } from '@/lib/query/query-keys';
import { useRouter } from '@/lib/navigation';

export function useLogin() {
  const router = useRouter();

  return useCallback((redirectPath?: string | null) => {
    // In dev mode with VITE_DEV_ACCESS_TOKEN, skip OAuth and go directly to home
    // The token is already set by initializeAuthSession()
    if (isDevTokenAuthActive()) {
      router.push(redirectPath || '/');
      return;
    }

    redirectToOAuthLogin(redirectPath);
  }, [router]);
}

export function useLogout() {
  const queryClient = useQueryClient();
  const router = useRouter();

  return useMutation({
    mutationFn: async () => {
      await logoutCurrentSession();
    },
    onSettled: () => {
      queryClient.removeQueries({ queryKey: queryKeys.user });
      router.push('/login');
    },
  });
}
